var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDropDown = function SvgArrowDropDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.667.667 4 4 7.333.667H.667Z",
    fill: "#AEAEAE"
  })));
};
export { SvgArrowDropDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI0IiB2aWV3Qm94PSIwIDAgOCA0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC42NjY2MjYgMC42NjY2MjZMMy45OTk5NiAzLjk5OTk2TDcuMzMzMjkgMC42NjY2MjZIMC42NjY2MjZaIiBmaWxsPSIjQUVBRUFFIi8+Cjwvc3ZnPgo=";